function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg249Nepal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "0,512 0,0 280.419,262.131 87.61,262.131 271.186,512 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "244.769,246.832 10.199,27.56 10.199,246.832 10.199,496.701 244.769,496.701   61.193,246.832 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "106.819,367.304 88.627,358.747 98.314,341.129 78.56,344.908 76.056,324.952    62.297,339.629 48.538,324.952 46.033,344.908 26.28,341.129 35.967,358.747 17.775,367.304 35.967,375.861 26.28,393.48    46.034,389.701 48.536,409.657 62.297,394.98 76.056,409.657 78.56,389.701 98.314,393.48 88.626,375.861  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "99.398,162.343 84.238,155.212 92.311,140.53 75.848,143.679 73.764,127.049 62.297,139.28    50.83,127.049 48.745,143.679 32.282,140.53 40.356,155.212 25.195,162.343 62.297,169.762  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M106.819,162.343c0,24.588-19.933,44.522-44.522,44.522s-44.522-19.933-44.522-44.522"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg249Nepal);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3Qgc3R5bGU9ImZpbGw6I0YwRjBGMDsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIi8+Cjxwb2x5Z29uIHN0eWxlPSJmaWxsOiMwMDUyQjQ7IiBwb2ludHM9IjAsNTEyIDAsMCAyODAuNDE5LDI2Mi4xMzEgODcuNjEsMjYyLjEzMSAyNzEuMTg2LDUxMiAiLz4KPHBvbHlnb24gc3R5bGU9ImZpbGw6I0Q4MDAyNzsiIHBvaW50cz0iMjQ0Ljc2OSwyNDYuODMyIDEwLjE5OSwyNy41NiAxMC4xOTksMjQ2LjgzMiAxMC4xOTksNDk2LjcwMSAyNDQuNzY5LDQ5Ni43MDEgICA2MS4xOTMsMjQ2LjgzMiAiLz4KPGc+Cgk8cG9seWdvbiBzdHlsZT0iZmlsbDojRjBGMEYwOyIgcG9pbnRzPSIxMDYuODE5LDM2Ny4zMDQgODguNjI3LDM1OC43NDcgOTguMzE0LDM0MS4xMjkgNzguNTYsMzQ0LjkwOCA3Ni4wNTYsMzI0Ljk1MiAgICA2Mi4yOTcsMzM5LjYyOSA0OC41MzgsMzI0Ljk1MiA0Ni4wMzMsMzQ0LjkwOCAyNi4yOCwzNDEuMTI5IDM1Ljk2NywzNTguNzQ3IDE3Ljc3NSwzNjcuMzA0IDM1Ljk2NywzNzUuODYxIDI2LjI4LDM5My40OCAgICA0Ni4wMzQsMzg5LjcwMSA0OC41MzYsNDA5LjY1NyA2Mi4yOTcsMzk0Ljk4IDc2LjA1Niw0MDkuNjU3IDc4LjU2LDM4OS43MDEgOTguMzE0LDM5My40OCA4OC42MjYsMzc1Ljg2MSAgIi8+Cgk8cG9seWdvbiBzdHlsZT0iZmlsbDojRjBGMEYwOyIgcG9pbnRzPSI5OS4zOTgsMTYyLjM0MyA4NC4yMzgsMTU1LjIxMiA5Mi4zMTEsMTQwLjUzIDc1Ljg0OCwxNDMuNjc5IDczLjc2NCwxMjcuMDQ5IDYyLjI5NywxMzkuMjggICAgNTAuODMsMTI3LjA0OSA0OC43NDUsMTQzLjY3OSAzMi4yODIsMTQwLjUzIDQwLjM1NiwxNTUuMjEyIDI1LjE5NSwxNjIuMzQzIDYyLjI5NywxNjkuNzYyICAiLz4KCTxwYXRoIHN0eWxlPSJmaWxsOiNGMEYwRjA7IiBkPSJNMTA2LjgxOSwxNjIuMzQzYzAsMjQuNTg4LTE5LjkzMyw0NC41MjItNDQuNTIyLDQ0LjUyMnMtNDQuNTIyLTE5LjkzMy00NC41MjItNDQuNTIyIi8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };